import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { httpInterceptorProviders } from './interceptors';
import { InfoDialogComponent } from './components/info-dialog/info-dialog.component';
import { FormDialogComponent } from './components/form-dialog/form-dialog.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { OtpConfirmationDialogComponent } from './components/otp-confirmation-dialog/otp-confirmation-dialog.component';
import { RideshareDialogComponent } from './components/rideshare-dialog/rideshare-dialog.component';
import { RouterModule } from '@angular/router';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { TermsDialogComponent } from './components/terms-dialog/terms-dialog.component';
import { TosDialogComponent } from './components/tos-dialog/tos-dialog.component';
import { FedexLocationLookupDialogComponent } from './components/fedex-location-lookup-dialog/fedex-location-lookup-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { FedexLocationComponent } from './components/fedex-location-lookup-dialog/fedex-location/fedex-location.component';
import { SharedModule } from '../shared/shared.module';
import { ConnectButtonComponent } from './components/uber/connect-button/connect-button.component';
import { UberConnectComponent } from './components/uber/uber-connect/uber-connect.component';
import { UberDialogComponent } from './components/uber/uber-dialog/uber-dialog.component';
import { ConfirmationDialogChangedMessageComponent } from './components/confirmation-dialog-changed-message/confirmation-dialog-changed-message.component';
import { UberDisconnectDialogComponent } from './components/uber-disconnect-dialog/uber-disconnect-dialog.component';
import { UpdateContactInfoDialogComponent} from './components/update-contact-info-dialog/update-contact-info-dialog.component';
import { ChooseCashoutMethodDialogComponent } from './components/choose-cashout-method-dialog/choose-cashout-method-dialog.component';

@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        NavMenuComponent,
        InfoDialogComponent,
        ConfirmationDialogComponent,
        FormDialogComponent,
        OtpConfirmationDialogComponent,
        RideshareDialogComponent,
        BreadcrumbComponent,
        TermsDialogComponent,
        TosDialogComponent,
        FedexLocationLookupDialogComponent,
        FedexLocationComponent,
        ConnectButtonComponent,
        UberConnectComponent,
        UberDialogComponent,
        ConfirmationDialogChangedMessageComponent,
        UberDisconnectDialogComponent,
        UpdateContactInfoDialogComponent,
        ChooseCashoutMethodDialogComponent
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        MatDialogModule,
        MatButtonModule,
        MatRadioModule,
        MatProgressSpinnerModule,
        MatIconModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatFormFieldModule,
        MatListModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        SharedModule,
    ],
    exports: [
        HeaderComponent,
        FooterComponent,
        NavMenuComponent,
        BreadcrumbComponent,
        ConnectButtonComponent,
        UberConnectComponent,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        RouterModule,
        CommonModule,
    ],
    providers: [httpInterceptorProviders],
})
export class CoreModule {}
